export const getMetaTag = (metaHTML: string, name: string) => {
  const catchContent = new RegExp(
    'meta name="' + name + '" content="([^"]*)',
    'gi',
  )

  const result = metaHTML ? catchContent.exec(metaHTML)?.[1] : ''
  return result
}
const splitByTag = (
  html: string,
  startSearch: string,
  endSearches: string[],
) => {
  const continueIndex = html.indexOf(startSearch)
  const beforePart = html.substring(0, continueIndex)
  const foundEnds = endSearches.map((endSearch) => {
    return {
      index: html.indexOf(endSearch, continueIndex),
      length: endSearch.length,
    }
  })
  const foundEnd = foundEnds.find((foundEnd) => foundEnd.index > -1)
  if (!foundEnd) {
    return [beforePart, html.substring(continueIndex), '']
  } else {
    const finalEnd = foundEnd.index + foundEnd.length
    const continuePart = html.substring(continueIndex, finalEnd)
    const afterPart = html.substring(finalEnd)
    return [beforePart, continuePart, afterPart]
  }
}

export const splitHtml2 = (html: string) => {
  const splittedHtml: string[] = []
  const splittedTag = splitSpecialTag(html)
  splittedHtml.push(...splittedTag)
  return splittedHtml.filter((s) => !!s.trim())
}

const divSelectors = [
  {
    identifier: '<div class="flat-after-first-paragraph',
    ends: ['</div>', '/>', '>'],
  },
  {
    identifier: '<div class="percentages-',
    ends: ['</div>', '/>', '>'],
  },
  {
    identifier: '<div data-embed-type="',
    ends: ['</div>', '/>', '>'],
  },
  {
    identifier: '<div data-embed-type="',
    ends: ['</div>', '/>', '>'],
  },
  {
    identifier: '<div class="after-3rd-paragraph',
    ends: ['</div>', '/>', '>'],
  },
  // {
  //   identifier: '<table',
  //   ends: ['</table>'],
  // },
  // {
  //   identifier: '<ul',
  //   ends: ['</ul>'],
  // },
  {
    identifier: '[article-yoast-faqs',
    ends: [']'],
  },
  { identifier: '[embed-health-tool', ends: [']'] },
  { identifier: '<h3 data-tableid', ends: ['</h3>', '/>', '>'] },
  { identifier: '<h2 data-tableid', ends: ['</h2>', '/>', '>'] },
  // {
  //   identifier: '<div class="continue-reading-articles',
  //   ends: ['</div>', '/>', '>'],
  // },
]
const splitSpecialTag = (s: string) => {
  const res: string[] = []
  if (s)
    divSelectors.every((selector) => {
      if (s.indexOf(selector.identifier) > -1) {
        const [beforePart, continuePart, afterPart] = splitByTag(
          s,
          selector.identifier,
          selector.ends,
        )
        res.push(...splitSpecialTag(beforePart))
        res.push(continuePart)
        res.push(...splitSpecialTag(afterPart))
        return false
      }
      return true
    })
  if (!res.length) {
    res.push(s)
  }
  return res
}

export const renderAppBanner = ({
  position,
  appObj,
  isMobile,
}: {
  position: string
  appObj?: any
  isMobile?: boolean
}) => {
  if (!appObj) return ''
  if (position !== appObj.class) return ''
  const bannerSrc = isMobile ? appObj?.banner?.mobile : appObj?.banner?.desktop
  return `<a data-event-category="App Banner"
    data-event-action="${position}"
    data-event-label="${appObj.url}" 
    href="${appObj.url}" 
    target="_blank" 
    alt="Mobile app">
    <img src="${bannerSrc}" alt="App Banner"/>
  </a>`
}
